(function initCartoonPuzzleRenderer() {
    function renderCartoonPuzzleOffer({ offerAssembly, dn } = {}) {
        if (!offerAssembly) return;

        const beforeImageEl = document.querySelector('#before-pet');
        const afterImageEl = document.querySelector('#after-pet');
        const headingLabel = document.querySelector('h3.puzzle-title') || document.querySelector('.puzzle-title');
        const dnText = typeof dn === 'string' && dn.trim() ? dn.trim() : '';

        if (dnText && headingLabel) {
            headingLabel.innerHTML = 'Cartoon Puzzle ft. ' + dnText;
        }

        const beforeSrc = offerAssembly?.submission_images_cropped?.[0];
        const afterSrc = offerAssembly?.image_files_used_cropped?.[0]
            ? 'https://res.cloudinary.com/da9yd4bgx/image/fetch/t_puzzle-v1/' +
            encodeURIComponent(offerAssembly.image_files_used_cropped[0])
            : '';

        if (beforeImageEl && beforeSrc) {
            beforeImageEl.src = beforeSrc;
            beforeImageEl.removeAttribute('srcset');
            ensureLightboxWrap(beforeImageEl, beforeSrc, `${dnText}`);
        }

        if (afterImageEl && afterSrc) {
            afterImageEl.src = afterSrc;
            afterImageEl.removeAttribute('srcset');
            ensureLightboxWrap(afterImageEl, afterSrc, `${dnText} Puzzle`);
        }

        // Initialize (or re-scan) GLightbox
        if (window.GLightbox) {
            // If you already created a GLightbox instance elsewhere, you can call .reload()
            // Otherwise just (re)create with the selector:
            window._cartoonPuzzleLB = window._cartoonPuzzleLB || GLightbox({ selector: '.glightbox-cartoon' });
            if (window._cartoonPuzzleLB.reload) window._cartoonPuzzleLB.reload();
        }
    }

    window.renderCartoonPuzzleOffer = renderCartoonPuzzleOffer;
})();
